import { useParams } from 'react-router-dom';
import { useGetTagsQuery } from '@/features/tags/api';
import { useGetIngredientsQuery } from '@/features/ingredients/api';
import { ChipMultiSelect } from '@/components/ChipMultiSelect';
import { RangeSlider } from '@/components/RangeSlider';
import { FiltersButton } from '@/components/FiltersButton';
import { FilterSection } from '@/components/FilterSection';
import { EmojiDisplay } from '@/components/EmojiDisplay';
import { newRecipeFilters } from '@/features/recipes/schema.js';
import { RANGE_FILTERS, countActiveFilters } from '@/features/recipes/filters.js';

export function RecipeFiltersButton({ filters, setFilters, bounds, resultsCount, sx, open, onOpenChange }) {
  const { householdId } = useParams();
  const tags = useGetTagsQuery({ householdId });
  const ingredients = useGetIngredientsQuery();

  const tagOptions = (tags.data?.data || []).map(tag => ({
    name: tag.name,
    icon: tag.emoji && <EmojiDisplay emoji={tag.emoji} size={14} />,    
  }));
  const ingredientOptions = ingredients.data?.data || [];

  const activeCount = countActiveFilters(filters);

  const clearAll = () => {
    const defaults = newRecipeFilters();
    setFilters({
      ...filters,
      tags: defaults.tags,
      ingredients: defaults.ingredients,
      prepTime: defaults.prepTime,
      cookTime: defaults.cookTime,
      totalTime: defaults.totalTime,
      calories: defaults.calories,
    });
  };

  return (
    <FiltersButton
      activeCount={activeCount}
      onClearAll={clearAll}
      resultsCount={resultsCount}
      resultsLabel="recipes"
      sx={sx}
      open={open}
      onOpenChange={onOpenChange}
    >
      <FilterSection title="Tags">
        <ChipMultiSelect
          value={filters.tags}
          onChange={(tags) => setFilters({ ...filters, tags })}
          options={tagOptions}
          size="sm"
          entity="tags"          
        />
      </FilterSection>
      <FilterSection title="Ingredients">
        <ChipMultiSelect
          value={filters.ingredients}
          onChange={(ingredients) => setFilters({ ...filters, ingredients })}
          options={ingredientOptions}
          size="sm"
          entity="ingredients"          
        />
      </FilterSection>
      {RANGE_FILTERS.map((range) => (
        <RangeSlider
          key={range.key}
          label={range.label}
          unit={range.unit}
          value={filters[range.key]}
          bounds={bounds[range.key]}
          onChange={(value) => setFilters({ ...filters, [range.key]: value })}
        />
      ))}
    </FiltersButton>
  );
}
